import React from 'react'
import materialhome from '../../Assets/materialhome.png'
import materialhomejs from '../../Assets/materialhomejs.png'
import materialhomehtml from '../../Assets/materialhomehtml.png'
import materialhomephp from '../../Assets/materialhomephp.png'


import { Link } from 'react-router-dom';
const PageMaterials = () => {
    return (
        <div className="container">
            <header className="py-2">
                        <div className="container px-5">
                            <div className="row gx-5 align-items-center justify-content-center">
                                <div className="col-lg-8 col-xl-7 col-xxl-6">
                                    <div className="my-5 text-center text-xl-start">
                                        <h1 className="display-5 fw-bolder text-white mb-2">Materiały Do Nauki Przed Egzaminem</h1>
                                        <p className="lead fw-normal text-white-50 mb-4">Znajdziesz tutaj przydatne informacje oraz zasoby do przygotowania się do egzaminu zawodowego. Dowiesz się, jakie są wymagania egzaminacyjne oraz jakie zadania będziesz musiał wykonać podczas części praktycznej i teoretycznej.</p>
                                        <div className="d-grid gap-3 d-sm-flex justify-content-sm-center justify-content-xl-start">
                                            <a className="btn btn-primary btn-lg px-4 me-sm-3" href="#features">Rozpocznij</a>
                                            <Link className="btn btn-outline-light btn-lg px-4" to="/materialy#materialpageinfo">Dowiedz się więcej</Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-5 col-xxl-6 d-none d-xl-block text-center"><img className="img-fluid rounded-3 my-5" src={materialhome} alt="..." /></div>
                            </div>
                        </div>
            </header>
            <div id="materialpageinfo" className="container my-5 p-3 rounded-3">


            <section className="py-4">
                <div className="container px-5 my-5">
                    <div className="row gx-5 justify-content-center">
                        <div className="col-lg-8 col-xl-6">
                            <div className="text-center">
                                <h2 className="fw-bolder">Materiały Do Nauki</h2>
                                <p className="lead fw-normal text-muted mb-5">Pod spodem znajdują się różne materiały, które pozwolą tobie przypomnieć sobie wiedzę lub nauczyć się czegoś nowego!</p>
                            </div>
                        </div>
                    </div>
                    <div className="row gx-5">
                        <div className="col-lg-4 mb-5">
                            <div className="card h-100 shadow border-0">
                                <img className="card-img-top" src={materialhomehtml} alt="..." />
                                <div className="card-body p-4">
                                    <div className="badge bg-primary bg-gradient rounded-pill mb-2">Nauka</div>
                                    <a className="text-decoration-none link-primary stretched-link" href="#!"><h5 className="card-title mb-3">Podstawa strony HTML</h5></a>
                                    <p className="card-text mb-0">Szybki poradnik jak nauczyć się HTML i jego najważniejsze rzeczy, które przydadzą się by zdać egzamin!</p>
                                </div>
                                <div className="card-footer p-4 pt-0 bg-transparent border-top-0">
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="small">
                                                <div className="text-muted">Czerwiec 20, 2024 &middot; 6 min czytania</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-5">
                            <div className="card h-100 shadow border-0">
                                <img className="card-img-top" src={materialhomejs} alt="..." />
                                <div className="card-body p-4">
                                    <div className="badge bg-primary bg-gradient rounded-pill mb-2">Nauka</div>
                                    <a className="text-decoration-none link-primary stretched-link" href="#!"><h5 className="card-title mb-3">Javascript</h5></a>
                                    <p className="card-text mb-0">Najważniejsze rzeczy z javascripta, które przydzadzą się na egzamin (podstawy)</p>
                                </div>
                                <div className="card-footer p-4 pt-0 bg-transparent border-top-0">
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="small">
                                                <div className="text-muted">Czerwiec 20, 2024 &middot; 10 min czytania</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-5">
                            <div className="card h-100 shadow border-0">
                                <img className="card-img-top" src={materialhomephp} alt="..." />
                                <div className="card-body p-4">
                                    <div className="badge bg-primary bg-gradient rounded-pill mb-2">Nauka</div>
                                    <a className="text-decoration-none link-primary stretched-link" href="#!"><h5 className="card-title mb-3">PHP - backendowy server</h5></a>
                                    <p className="card-text mb-0">PHP , czyli w głównej mierze łączenie się z bazą danych, pobieranie danych,wyświetlanie,zapisywanie oraz zamknięcie połączenia</p>
                                </div>
                                <div className="card-footer p-4 pt-0 bg-transparent border-top-0">
                                    <div className="d-flex align-items-end justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <div className="small">
                                                <div className="text-muted">Czerwiec 20, 2024 &middot; 9 min czytania</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                 
                    {/* <aside className="bg-primary bg-gradient rounded-3 p-4 p-sm-5 mt-5">
                        <div className="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
                            <div className="mb-4 mb-xl-0">
                                <div className="fs-3 fw-bold text-white">New products, delivered to you.</div>
                                <div className="text-white-50">Sign up for our newsletter for the latest updates.</div>
                            </div>
                            <div className="ms-xl-4">
                                <div className="input-group mb-2">
                                    <input className="form-control" type="text" placeholder="Email address..." aria-label="Email address..." aria-describedby="button-newsletter" />
                                    <button className="btn btn-outline-light" id="button-newsletter" type="button">Sign up</button>
                                </div>
                                <div className="small text-white-50">We care about privacy, and will never share your data.</div>
                            </div>
                        </div>
                    </aside> */}
                </div>
            </section>








    <h1 className="display-6 fw-bold md-2">Podstawowe informacje dotyczące egzaminu INF</h1>
    
    <div className="p-5 text-center my-5 bg-body-tertiary rounded-3" style={{marginRight:"40px",marginLeft:"40px"}}>
            <h1 className="text-body-emphasis">Co obejmuje egzamin?</h1>
            <p className="text-start fs-5"><br/>
            Egzamin zawodowy INF składa się z dwóch części: teoretycznej (pisemnej) oraz praktycznej.<br/><br/>

            Część teoretyczna trwa <span className="text-danger">60 minut</span> i zawiera <span className="text-primary">40 zamkniętych pytań</span>.  Każde pytanie ma 4 odpowiedzi, z których tylko jedna jest poprawna.<br/><br/>

            Część praktyczna trwa <span className="text-danger">240 minut</span>. Podczas tego czasu zdający musi wykonać praktyczne zadania określone w arkuszu egzaminacyjnym.
            </p>
        </div>

        <div className="p-5 text-center my-5 bg-body-tertiary rounded-3" style={{marginRight:"40px",marginLeft:"40px"}}>
            <h1 className="text-body-emphasis">Jakie są wymagania do zdania egzaminu?</h1>
            <p className="text-start fs-5"><br/>
            Część teoretyczna (pisemna)- minimalnie <span className="text-success">50%</span> punktów (co najmniej 20 punktów).<br/><br/>

            Część praktyczna - minimalnie <span className="text-success">75%</span> punktów.
            </p>
        </div>

        <div className="p-5 text-center my-5 bg-body-tertiary rounded-3" style={{marginRight:"40px",marginLeft:"40px"}}>
            <h1 className="text-body-emphasis">Co jeśli nie zdałem egzaminu?</h1>
            <p className="text-start fs-5"><br/>
            Aby zdać cały egzamin, należy zaliczyć obie jego części. Co jednak, jeśli nie osiągniemy wymaganych procentów w jednej z części?

            Możliwe jest poprawienie tylko jednej niezaliczonej części egzaminu. W przypadku niezaliczenia obu, konieczne jest ponowne podejście do całego egzaminu.
            </p>
        </div>
    </div>


	</div>
	

      );
}

export default PageMaterials